import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefono',
})
export class TelefonoPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    if (typeof value !== 'string') return value;
    // Espera formato +51111111111
    const match = value.match(/^(\+\d{2})(\d{3})(\d{3})(\d{3})$/);
    if (!match) return value;
    // match[1]: +51, match[2]: 111, match[3]: 111, match[4]: 111
    return `${match[1]}-${match[2]}-${match[3]}-${match[4]}`;
  }
}
